module.exports = __webpack_public_path__ + "media/images/athletes/2149-05ab3ed60fade4e333b90d132aa2fcaa.png";